import { uiRows } from './types-def.js';
/** `web/when` (1.O-1): the When input and placements. */
export const WHEN_INTERACTIONS = uiRows([
    {
        id: 'chrono.when.preview',
        module: 'web/when',
        behavior: 'The When input shows a live preview for every phrase class',
        owner: '1.O-1',
        since: 'exit-1b',
    },
    {
        id: 'chrono.placement.picker',
        module: 'web/when',
        behavior: 'A relative date against a document with several placements asks which one',
        owner: '1.O-1',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=when.js.map